
export enum TiposConfiguracion {
    Mocks = "Mocks",
    V2 = "V2",
    V3 = "V3"
  }